import { logger as log } from '@common/logger';
import { OrganisationProfilePageService } from '../../../services';
import { vappContainer } from '@/application';

//as
const MODULE_NAME = 'profile.machines.states.updateDocRejectProfile';

const getSrv = () => {
  return vappContainer.get<OrganisationProfilePageService>(
    OrganisationProfilePageService.displayName
  );
};

export const updateDocRejectProfile = async (context: any, event: any) => {
  const currentState = 'UPDATE_DOC_REJECT_PROFILE';
  const method = 'updateDocRejectProfile';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.getDocRejectUpdate(event?.payload);
      if (content) {
        return resolve({
          key: 'UPDATE_DOC_REJECT_PROFILE_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'UPDATE_DOC_REJECT_PROFILE_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'UPDATE_DOC_REJECT_PROFILE_FAILED',
        value: _msg,
      });
    }
  });
};
